/**
 * The workspace switch's door (PV5-8:D part 2, 2026-10-13): which overlay the app's switch draws, and in which light.
 * src/components/WorkspaceTransitionOverlay.tsx asks both where it draws the overlay, synchronously: the overlay must
 * cover the page the moment a switch begins, and the moment the app mounts after the reload, so nothing here waits on
 * a download (the new design's overlay rides the first download with today's).
 */
import { designShows } from '../../previewPath';
import { resolvePreviewTheme } from '../../previewTheme';
import { switchLightOf, type SwitchLight } from './switchLooks';

/** The new design's switch shows where the `splash` surface does: the demonstration address always, prest0.ai once live. */
export const showsNewSwitch = (): boolean => designShows('splash');

/**
 * The visitor's light: the address's `?theme=`, else their own choice, else the device's (resolvePreviewTheme), as the
 * boot splash resolves it before the app has loaded (public/index.html's head script; tests/workspaces/splashLight.test.ts
 * holds the two equal), so the splash and the overlay that takes over from it are drawn in the same light.
 */
export const switchLight = (): SwitchLight => switchLightOf(resolvePreviewTheme());
